// src/encounter/vitals-history/vitals-history-slot.tsx
// Where hosts open the vitals history (encounter + pre-visit History, the appointment panel's View Vitals). Antonin's modal,
// styles and scoped tokens load on demand only, when it opens: a static import would put the whole catalog in every user's
// first download (as device-trends-slot.tsx).
import { lazy, Suspense } from 'react';
import type { VitalsHistoryModalProps } from './vitals-history-modal';

const VitalsHistoryModal = lazy(() => import('./vitals-history-modal').then((m) => ({ default: m.VitalsHistoryModal })));

export function VitalsHistorySlot(props: VitalsHistoryModalProps) {
  if (!props.open) return null;
  return <Suspense fallback={null}><VitalsHistoryModal {...props} /></Suspense>;
}
